import { Component, Input } from '@angular/core';
import { FieldType } from '@sb-tools/typescript/enums/field-type.enum';
import { SurveyDTO } from '../../../core/models/dto/survey.dto';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '../../../../sb-tools/typescript/pipes/safe-html.pipe';
import { NewLinePipe } from '../../../../sb-tools/typescript/pipes/new-line.pipe';
import { NumberToArrayPipe } from '../../../../sb-tools/typescript/pipes/number-to-array.pipe';
import { DateTimePipe } from '../../../shared/pipes/date-time.pipe';

@Component({
    selector: 'app-thread-survey-result',
    templateUrl: './thread-survey-result.component.html',
    styleUrls: ['./thread-survey-result.component.scss'],
    imports: [InlineSVGComponent, TranslateModule, SafeHtmlPipe, NewLinePipe, NumberToArrayPipe, DateTimePipe],
})
export class ThreadSurveyResultComponent {
    @Input() threadElement: SurveyDTO;

    readonly fieldTypeEnum = FieldType;
}
